export default __webpack_public_path__ + "overviewa508f0.png";